"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgets = void 0;
const homeWidgets = __importStar(require("./sections/home/widgets"));
const householdWidgets = __importStar(require("./sections/household/widgets"));
const personsTripsWidgets = __importStar(require("./sections/personsTrips/widgets"));
const selectPersonWidgets = __importStar(require("./sections/selectPerson/widgets"));
const tripsIntroWidgets = __importStar(require("./sections/tripsIntro/widgets"));
const visitedPlacesWidgets = __importStar(require("./sections/visitedPlaces/widgets"));
const segmentsWidgets = __importStar(require("./sections/segments/widgets"));
const travelBehaviorWidgets = __importStar(require("./sections/travelBehavior/widgets"));
const longDistanceWidgets = __importStar(require("./sections/longDistance/widgets"));
const endWidgets = __importStar(require("./sections/end/widgets"));
const completedWidgets = __importStar(require("./sections/completed/widgets"));
// Define all the widgets
const widgets = {};
exports.widgets = widgets;
// Define all the sections widgets
const sectionsWidgets = [
    homeWidgets,
    householdWidgets,
    personsTripsWidgets,
    selectPersonWidgets,
    tripsIntroWidgets,
    visitedPlacesWidgets,
    segmentsWidgets,
    travelBehaviorWidgets,
    longDistanceWidgets,
    endWidgets,
    completedWidgets
];
// Loop all sections and add their widgets to the widgets object
sectionsWidgets.forEach((section) => {
    for (const widget in section) {
        widgets[widget] = section[widget];
    }
});
